import React from "react";
import { Link } from "react-router-dom";
import { Scissors, ArrowLeft } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function AuthShell({ title, subtitle, children, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-[#0A0A0A]">
      <div className="hidden lg:block relative">
        <img src={HERO} alt="Barber" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/50 to-black/40" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12">
          <Link to="/" className="flex items-center gap-3 w-fit">
            <span className="w-10 h-10 rounded-full border border-[#D4AF37]/50 flex items-center justify-center">
              <Scissors className="w-5 h-5 text-[#D4AF37]" />
            </span>
            <span className="font-display text-2xl">Who's Next</span>
          </Link>
          <div>
            <h2 className="font-display text-5xl leading-tight">Preston's premium<br />grooming, reserved<br />in seconds.</h2>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 relative">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden flex items-center gap-2 text-gray-400 text-sm mb-8">
            <ArrowLeft className="w-4 h-4" /> Back home
          </Link>
          <h1 className="font-display text-5xl tracking-tight mb-2">{title}</h1>
          <p className="text-gray-400 mb-8">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}
